module.exports = __webpack_public_path__ + "img/product-6.c4ca546a.jpg";